<template>
    <div>
        <div v-if="$store.state.user.teamHubChecklists && $store.state.user.companyID == 1" class="my-checklist-single">
            <div class="my-checklist-single-top">
                <div class="my-checklist-single-icon">
                    <svg-icon icon="checklist" />
                </div>
                <div>
                    <div class="my-checklist-single-text">The most experienced airline captain alive still runs the checklist before every takeoff — not because he forgot how to fly, but because fatigue, stress, and one badly-timed interruption don't care how good you are. The checklist doesn't slow the expert down. It frees them up — so when your attention gets hijacked, the one step you'd have missed is already caught, and your focus stays on the work that matters.</div>
                    <button v-for="(c, i) in $store.state.user.teamHubChecklists" :key="i" :title="c.Name" @click.prevent="openChecklist(c)" type="button" class="btn my-checklist-single-btn">{{ c.Name }}</button>
                </div>
            </div>
        </div>
        <div v-if="roleLabel" class="role-banner" @click="showRole()">
            <div class="role-banner-left">
                <div class="role-banner-icon">
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
                </div>
                <div class="role-banner-info">
                    <div class="role-banner-eyebrow">Your Assigned Role</div>
                    <div class="role-banner-title">{{ roleLabel }}</div>
                    <div class="role-banner-meta">
                        <!--
                        <span class="role-banner-pill">Sheetfoam</span>
                        -->
                        <span class="role-banner-loc">{{ $store.state.user.teamHubEmployee.Location }}</span>
                    </div>
                </div>
            </div>
            <div class="role-banner-action">View role sheet</div>
        </div>
        <!-- Your scorecard numbers still to enter (also the header's Numbers quick add) -->
        <my-numbers />
        <div v-if="$store.state.user.teamHubChecklists && $store.state.user.teamHubChecklists.length && $store.state.user.companyID != 1" class="my-checklists">
            <div class="my-checklists-label">My Powerlists</div>
            <div class="my-checklists-list">
                <div v-for="(c, i) in $store.state.user.teamHubChecklists" :key="i" :title="c.Name" @click.prevent="openChecklist(c)" class="my-checklist-link">
                    <svg-icon icon="checklist" />
                    <span>{{ c.Name }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import { findSeat, seatLabel } from '@/roleSheet';
import SvgIcon from './SvgIcon.vue';
import MyNumbers from './MyNumbers.vue';

export default defineComponent({
    name: 'EmployeeHomeNode',
    props: [  ],
    components: {
        SvgIcon,
        MyNumbers
    },
    data() {
        return {
            roleLabel: null as any,
            checklists: [] as any
        }
    },
    created() {
        const employee = this.$store.state.user.teamHubEmployee;
        const found = findSeat(this.$store.state.allNodes, employee.RoleSheetSlug, employee.RoleSheetColID);
        if(found) {
            this.roleLabel = seatLabel(found.seat) || found.node.Name;
        }
    },
    methods: {
        showRole() {
            this.$store.state.RoleSheetSlug = this.$store.state.user.teamHubEmployee.RoleSheetSlug;
            this.$store.state.RoleSheetColID = this.$store.state.user.teamHubEmployee.RoleSheetColID;
            this.$store.state.showRoleCol = true;
        },
        openChecklist(c: any) {
            this.$store.state.selectedTeamHubChecklist = c.Slug;
            this.$store.state.showTeamHubChecklist = true;
        }
    }
});
</script>